import Wangeditor from './Wangeditor.vue';
export default Wangeditor;